export const tableBodyProp = {
  '& tr:hover td': {
    backgroundColor: '#ffffff',
    transition: 'background-color 200ms ease-in, font-weight 200ms ease-in',
  },
  '& td': {
    border: 'none !important',
    backgroundColor: '#ffffff',
    transition: 'background-color 200ms ease-in, font-weight 200ms ease-in',
  },
  '& .hoverNewRow:hover td': {
    backgroundColor: '#9fc0ea !important',
    transition: 'background-color 300ms ease-in, font-weight 300ms ease-in',
  },
  '& .hoverNewRow td': {
    backgroundColor: '#aed2ff !important',
    fontWeight: 'bold !important',
    transition: 'background-color 300ms ease-in, font-weight 300ms ease-in',
  },
  '& .hoverViewedRow:hover td': {
    backgroundColor: '#e3edfd !important',
    transition: 'background-color 300ms ease-in, font-weight 300ms ease-in',
  },
  '& .hoverNewErrorRow:hover td': {
    backgroundColor: '#ffa2a2 !important',
    transition: 'background-color 300ms ease-in, font-weight 300ms ease-in',
  },
  '& .hoverNewErrorRow td': {
    backgroundColor: '#fac5c5 !important',
    fontWeight: 'bold !important',
    transition: 'background-color 300ms ease-in, font-weight 300ms ease-in',
  },
  '& .hoverViewedErrorRow td': {
    backgroundColor: '#f6adad !important',
    transition: 'background-color 300ms ease-in, font-weight 300ms ease-in',
  },

  '& tr:has(.activeCellLink:hover) > td': {
    backgroundColor: '#ffffff',
    transition: '0.3s',
    cursor: 'pointer',
  },
  '& tr:has(.activeCellLink:hover) > td .hoverNewRow': {
    backgroundColor: '#9fc0ea !important',
    transition: '0.3s',
  },
  '& tr:has(.activeCellLink:hover) > td .hoverViewedRow': {
    backgroundColor: '#e3edfd !important',
    transition: '0.3s',
  },
  '& tr:has(.activeCellLink:hover) > td .hoverNewErrorRow': {
    backgroundColor: '#ffa2a2 !important',
    transition: '0.3s',
  },
};

const _bodyHover = {
  '& tr:hover td': {
    backgroundColor: '#f1f3f5',
    transition: 'background-color 200ms ease-in, font-weight 200ms ease-in',
  },
}

export const tableBodyHoverProp = {
  ...tableBodyProp,
  ..._bodyHover,
}

export const loadingOverlayProps = {
  display: 'none',
};

export const tableHeadCellProps = {
  sx: {
    '& .mantine-TableHeadCell-Content-Labels': {
      gap: 6,

      '& .mantine-TableHeadCell-Content-Wrapper': {
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        display: 'block',
      },
    },
  },
};

export const skeletonProps = {
  borderRadius: 10,
  backgroundColor: 'red',

  sx: {
    '& .mantine-Skeleton-visible': {
      borderRadius: 10,
      display: 'none',
      backgroundColor: 'red',
    },
    '& .mantine-Skeleton-root': {
      borderRadius: 10,
      display: 'none',
      backgroundColor: 'red',
    },
  },
};

export const TABLE_DEFAULT_SETTINGS = {
  enablePagination: false,
  enableRowNumbers: false,
  enableRowVirtualization: true,
  enableColumnResizing: true,
  enablePinning: true,
  enableClickToCopy: false,
  enableColumnOrdering: true,
  positionActionsColumn: 'last',
  columnVirtualizerProps: { overscan: 1 },
  enableStickyHeader: true,
  enableBottomToolbar: false,
  enableGlobalFilter: false,
  enableFilterMatchHighlighting: false,
  selectAllMode: 'all',
  getRowProps: {},
  editDisplayMode: 'table',
  getRowId: (originalRow) => originalRow.uuid,
  mantineTableHeadCellProps: tableHeadCellProps,
  mantineLoadingOverlayProps: loadingOverlayProps,
  mantineSkeletonProps: skeletonProps,
};
